<template>
<div>
  <div class="wrapper input-group">
    <span class="title">{{ $t(title)}} </span>
    <input type="text" :disabled="disabledInput" class="form-control" id="copied-tooltip" ref="target" :value="value" aria-label="Value">
    <b-icon 
      class="title clipboard-icon" 
      font-scale="2" 
      @click="copy()" 
      @keydown.enter="copy()"
      @keydown.space.prevent="copy()"
      icon="clipboard"
      tabindex="0"
      role="button"
      :aria-label="$t('Copy to clipboard')">
    </b-icon>
  </div>
  <b-tooltip ref="tooltip" target="copied-tooltip" noninteractive>
    {{ $t('Copied to clipboard') }}
  </b-tooltip>
</div>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "clipboard",
  props: {
    text: {
      type: String,
      default: "Empty paragraph"
    },
    title: {
      type: String,
      default: "Empty paragraph"
    },
    variables: Object,
    disabledInput: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    // console.log("disabled: ", this.variables, this.$store.state['referenceNumber'])
  },
  computed: {
    value () {
      let result = this.text;
      if (this.variables) {
        for (const variable in this.variables) {
          const value = this.$store.state[variable];
          result = value;
        }
      }
      return result;
    }
  },
  methods: {
    copy () {
      var copyText = this.$refs.target;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      navigator.clipboard.writeText(copyText.value);
      this.$refs.tooltip.$emit('open')
      setTimeout(() => {
        this.$refs.tooltip.$emit('close')
      }, 2000)
    },
    updateComponent: debounce(function (event) {
      this.$emit("component-updated", {
        text: event.target.innerText
      });
    }, 2000)
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  border: 1px solid var(--brand-color-4);
  border-radius: 16px;
  height: 60px;
  padding: 5px 20px 5px 20px;
  align-items: center;
  @media (max-width: 767px) {
    padding: 5px 10px;
    .b-icon {
      font-size: 20px !important;
    }
  }
}


.title {
  font-size: 16px;
  line-height: 26px;
  font-weight: bold;
  color: var(--brand-color-4);
  @media (max-width: 767px) {
    font-size: 12px;
  }
}

.clipboard-icon {
  cursor: pointer;
  &:focus {
    outline: 3px solid #0065D6;
    outline-offset: 2px;
    border-radius: 4px;
  }
}
input {
  font-size: 16px;
  line-height: 26px;
  font-weight: bold;
  border: none;
  background: transparent;
  padding: 5px;
  &:disabled {
    background: transparent;
  }

  @media (max-width: 767px) {
    font-size: 12px;
  }
}

</style>
